<template>
    <div class="py-4 container-fluid">
        <div class="card p-4 shadow-lg">
            <h5 class="mb-4">Generador de Reportes de Gestión y Campo</h5>

            <form @submit.prevent="fetchReport" class="row g-3 align-items-end">
                <div class="col-md-3">
                    <label class="form-control-label">Seleccione Reporte</label>
                    <select class="form-control" v-model="reportParams.type">
                        <option value="user_detail">Detalle de Tareas (Sábana)</option>
                        <option value="performance_by_branch.detail">Detalle por Sucursal</option>
                        <option value="performance_by_branch.summary">Resumen por Sucursal</option>
                        <option value="summary">Resumen por Empleado</option>
                        <option value="task_type">Resumen por Tipo de Tarea</option>
                        <option value="working_hours">Asistencia y Horas Activas</option>
                        <option value="all_tracking_data">Trayectoria GPS (Puntos)</option>
                    </select>
                </div>
                <div class="col-md-3" v-if="showUserFilter">
                    <label class="form-control-label">Seleccione Usuario</label>
                    <select class="form-control" v-model="reportParams.user_id">
                        <option :value="null">Todos los usuarios</option>
                        <option v-for="user in userList" :key="user.id" :value="user.id">
                            {{ user.full_name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-control-label">Fecha Inicio</label>
                    <input type="date" class="form-control" v-model="reportParams.start_date">
                </div>

                <div class="col-md-3">
                    <label class="form-control-label">Fecha Fin</label>
                    <input type="date" class="form-control" v-model="reportParams.end_date">
                </div>

                <div class="col-md-3">
                    <argon-button type="submit" color="success" fullWidth :disabled="isLoading">
                        <span v-if="isLoading">Cargando...</span>
                        <span v-else>Generar Reporte</span>
                    </argon-button>
                </div>
            </form>

            <hr class="mt-4">

            <div v-if="isLoading" class="text-center py-5">
                <div class="spinner-border text-success" role="status"></div>
                <p class="mt-2 text-sm">Procesando datos del servidor...</p>
            </div>

            <div v-else-if="reportData.length > 0">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <p class="text-muted mb-0">Registros encontrados: <strong>{{ reportData.length }}</strong></p>

                    <div class="d-flex gap-2">
                        <argon-button size="sm" color="success" @click="exportToExcel">
                            <i class="fas fa-file-excel me-1"></i> Excel
                        </argon-button>
                        <argon-button size="sm" color="danger" @click="exportToPDF">
                            <i class="fas fa-file-pdf me-1"></i> PDF
                        </argon-button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr class="bg-light">
                                <th v-for="(header, index) in tableHeaders" :key="index"
                                    class="text-uppercase text-xxs font-weight-bolder opacity-7 ps-2">
                                    {{ header.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rowIndex) in reportData.slice(0, 20)" :key="rowIndex">
                                <td v-for="(header, colIndex) in tableHeaders" :key="colIndex">
                                    <span class="text-xs font-weight-bold">
                                        {{ formatValue(row, header.key, rowIndex) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="reportData.length > 20" class="alert alert-info text-center mt-3 text-white">
                        Mostrando previa de 20 registros. Use <b>Excel</b> para descargar el total ({{ reportData.length }}).
                    </div>
                </div>
            </div>

            <div v-else-if="!isLoading && reportData.length === 0" class="alert alert-warning text-center py-4">
                No se encontraron datos. Verifique el rango de fechas y filtros.
            </div>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";
import Swal from 'sweetalert2';
import moment from "moment";
import { useReportPDFPrinter } from '@/composables/useReportPDFPrinter';
import { useReportExcelExporter } from '@/composables/useReportExcelExporter';
import { useCompanyConfig } from '@/composables/useCompanyConfig';

const companyId = localStorage.getItem('companyId');

export default {
    name: "ReportsView",
    components: { ArgonButton },
    setup(){
        const { companyConfig, isLoadingCiaConfig, fetchCompanyConfig } = useCompanyConfig();
        fetchCompanyConfig();

        return {
            companyConfig,
            isLoadingCiaConfig,
        };
    },
    data() {
        return {
            isLoading: false,
            reportData: [],
            reportParams: {
                company_id: parseInt(companyId),
                type: 'user_detail',
                start_date: moment().startOf('month').format('YYYY-MM-DD'),
                end_date: moment().format('YYYY-MM-DD'),
                user_id: null // Opcional por si quieres filtrar un solo empleado
            },
            branchId:parseInt(localStorage.getItem('branchId')),
            userRole:parseInt(localStorage.getItem('userLevel'))
        };
    },
    computed: {
        tableHeaders() {
            const type = this.reportParams.type;

            if (type === 'user_detail') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'FECHA ASIG.', key: 'assigned_at' },
                    { label: 'EMPLEADO', key: 'employee_name' },
                    { label: 'TAREA', key: 'task_description' },
                    { label: 'TIPO', key: 'type_name' },
                    { label: 'A COBRAR', key: 'to_collect' },
                    { label: 'COBRADO', key: 'collected' },
                    { label: 'PRIORIDAD', key: 'priority' },
                    { label: 'ESTADO', key: 'status' },
                    { label: 'COMPLETADO', key: 'completed_at' }
                ];
            } else if (type === 'performance_by_branch.detail') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'SUCURSAL', key: 'branch_name' },
                    { label: 'ASESOR', key: 'employee_name' },
                    { label: 'TAREAS ASIGNADAS', key: 'total_assigned' },
                    { label: 'TAREAS COMPLETADAS', key: 'total_completed' },
                    { label: '% TAREAS', key: 'compliance_rate' },
                    { label: 'REC. PROYECTADO $', key: 'assigned_amount' },
                    { label: 'REC. COBRADO $', key: 'realized_amount' },
                    { label: '% COBRO', key: 'collection_rate' }
                ];
            } else if (type === 'performance_by_branch.summary') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'SUCURSAL', key: 'branch_name' },
                    { label: 'TOTAL TAREAS ASIG.', key: 'total_assigned' },
                    { label: 'TOTAL TAREAS REAL.', key: 'total_completed' },
                    { label: 'TOTAL REC. PROYECTADO $', key: 'assigned_amount' },
                    { label: 'TOTAL COBRADO $', key: 'realized_amount' }
                ];
            } else if (type === 'summary') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'EMPLEADO', key: 'employee_name' },
                    { label: 'ASIGNADAS', key: 'total_assigned' },
                    { label: 'COMPLETADAS', key: 'total_completed' },
                    { label: 'CON EVIDENCIA', key: 'with_evidence' }
                ];
            } else if (type === 'working_hours') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'EMPLEADO', key: 'user_name' },
                    { label: 'FECHA', key: 'work_date' },
                    { label: 'ENTRADA', key: 'clock_in' },
                    { label: 'SALIDA', key: 'clock_out' },
                    { label: 'TOTAL HORAS', key: 'total_hours' },
                    { label: 'TAREAS OK', key: 'tasks_completed' }
                ];
            } else if (type === 'task_type') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'TIPO DE TAREA', key: 'type_name' },
                    { label: 'TOTAL', key: 'total_tasks' },
                    { label: 'COMPLETADAS', key: 'completed' }
                ];
            } else if (type === 'all_tracking_data') {
                return [
                    { label: '#', key: 'row_number' },
                    { label: 'EMPLEADO', key: 'employee_name' },
                    { label: 'FECHA/HORA', key: 'created_at' },
                    { label: 'LATITUD', key: 'latitude' },
                    { label: 'LONGITUD', key: 'longitude' }
                ];
            }
            return [];
        },
        showUserFilter() {
            const typesWithUser = ['user_detail', 'summary', 'working_hours', 'all_tracking_data','performance_by_branch.detail','task_type'];
            return typesWithUser.includes(this.reportParams.type);
        },
    },
    methods: {
        formatValue(row, key, index) {
            if (key === 'row_number') return index + 1;
            let value = row[key];
            if (value === null || value === 'null' || value === undefined) return '---';
            return value;
        },

        async fetchReport() {
            this.isLoading = true;
            this.reportData = [];

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;

            // "performance_by_branch.detail" -> se convierte en "performance_by_branch" para el API
            const serverType = this.reportParams.type.split('.')[0];

            const cleanParams = {
                ...this.reportParams,
                type: serverType // Sobrescribimos el tipo para la petición
            };
            if (this.userRole == 2 && this.branchId && this.branchId !== 'null') {
                cleanParams.branch_id = this.branchId;
            }
            if (!cleanParams.user_id) delete cleanParams.user_id;
            const params = new URLSearchParams(cleanParams).toString();

            try {
                const response = await axios.get(`${apiURL}reports/tasks?${params}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                let data = response.data || [];

                // SI ES RESUMEN: Agrupamos los datos por sucursal manualmente
                if (this.reportParams.type === 'performance_by_branch.summary') {
                    const summaryMap = {};
                    data.forEach(item => {
                        const b = item.branch_name || 'Sin Nombre';
                        if (!summaryMap[b]) {
                            summaryMap[b] = {
                                branch_name: b,
                                total_assigned: 0,
                                total_completed: 0,
                                assigned_amount: 0,
                                realized_amount: 0
                            };
                        }
                        summaryMap[b].total_assigned += parseInt(item.total_assigned || 0);
                        summaryMap[b].total_completed += parseInt(item.total_completed || 0);
                        summaryMap[b].assigned_amount += parseFloat(item.assigned_amount || 0);
                        summaryMap[b].realized_amount += parseFloat(item.realized_amount || 0);
                    });
                    this.reportData = Object.values(summaryMap);
                } else {
                    this.reportData = data;
                }

                if (this.reportData.length === 0) {
                    Swal.fire('Sin Datos', 'No se encontraron registros.', 'info');
                }
            } catch (err) {
                Swal.fire('Error', 'Error de comunicación.', 'error');
            } finally {
                this.isLoading = false;
            }
        },
        async fetchUsers() {
            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            let url = `${apiURL}users?company=${companyId}`;

            // Si es supervisor, solo traer usuarios de su sucursal
            if (this.userRole == 2 && this.branchId) {
                url += `&fk_branch_id=${this.branchId}`;
            }

            try {
                const response = await axios.get(url, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                this.userList = response.data || [];
            } catch (err) {
                console.error("Error cargando usuarios", err);
            }
        },
        exportToExcel() {
            if (!this.reportData.length) return;
            const filename = `Reporte_${this.reportParams.type}_${moment().format('YYYY-MM-DD')}.csv`;
            const columnLabels = this.tableHeaders.map(h => h.label);
            const columnKeys = this.tableHeaders.map(h => h.key);

            useReportExcelExporter(this.reportData, filename, columnLabels, columnKeys);
        },

        exportToPDF() {
            if (!this.reportData.length) return;
            useReportPDFPrinter(
                this.reportData,
                this.reportParams.type,
                this.companyConfig,
                this.reportParams.start_date,
                this.reportParams.end_date
            );
        }
    },
    mounted(){
        this.fetchUsers()
    }
};
</script>